<template>
  <CreateEditEventoModal
    v-if="showCreateEditEventoModal"
    :filters="filters"
    :eventoId="eventoIdSelected"
    @closeModal="closeModal"
  />
  <DeleteEventoModal
    v-if="showDeleteEventoModal"
    :eventoId="eventoIdSelected"
    @closeModal="closeModal"
  />
  <AvaliationEventoModal
    v-if="showAvaliationEventoModal"
    :eventoId="eventoIdSelected"
    @closeModal="closeModal"
  />
  <LinkEventosOrcamentoModal
    v-if="showLinkEventosOrcamentoModal"
    :periodo="eventos.periodo"
    :eventos="eventosSelecionadosAssociarOrcamento"
    :orcamento="eventos.orcamento"
    @closeModal="closeModal"
  />
  <UnlinkEventoOrcamentoModal
    v-if="showUnlinkEventoOrcamentoModal"
    :periodo="eventos.periodo"
    :evento="eventoSelectedUnlinkOrcamento"
    :orcamento="eventos.orcamento"
    @closeModal="closeModal"
  />
  <DetailsEventoModal
    v-if="showDetailsEventoModal"
    :eventoId="eventoIdSelected"
    @closeModal="closeModal"
  />
  <div class="card mt-4">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Eventos</h6>
      <div class="ms-auto my-auto">
        <button
          v-if="periodoCadastroIsOpen"
          type="button"
          class="btn btn-success"
          title="Novo Evento"
          @click="createEditEvento()"
        >
          Novo Evento
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row align-items-center g-3">
        <div class="col-md-6 d-flex flex-wrap gap-2">
          <span
            v-for="item in quantidadePorStatus"
            :key="item.status"
            class="fs-sm"
          >
            <span v-html="statusEventosTranslate(item.status, 'icone')" />
            {{ item.label }}: <strong>{{ item.total }}</strong>
          </span>
        </div>
        <div class="col-md-4">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar por nome"
            v-model="filtersResult.nome"
          />
        </div>
        <div class="col-md-2">
          <select class="form-select" v-model="filtersResult.status">
            <option value="">Todos os Status</option>
            <option :value="statusEventos.AGUARDANDO_APROVACAO">
              Aguardando Aprovação
            </option>
            <option :value="statusEventos.REPROVADO">Reprovado</option>
            <option :value="statusEventos.REFORMULADO">Reformulado</option>
            <option :value="statusEventos.APROVADO">Aprovado</option>
            <option :value="statusEventos.VINCULADO">Vinculado</option>
          </select>
        </div>
      </div>
      <hr />
      <div class="row align-items-center justify-content-end g-3">
        <div
          v-if="
            user.isAdmin &&
            periodoOrcamentoIsOpen &&
            existeEventoDisponivelParaAssociarOrcamento &&
            !selectedEventosAssociarOrcamento
          "
          class="col-md-4"
        >
          <button
            type="button"
            class="btn btn-outline-primary w-100"
            title="Selecionar Eventos para Associar ao Orçamento"
            @click="toggleSelectedEventosAssociarOrcamento"
          >
            Selecionar Eventos para Associar ao Orçamento
          </button>
        </div>
        <template v-if="selectedEventosAssociarOrcamento">
          <div class="col-md-2">
            <span class="fw-bold">
              {{ eventosSelecionadosAssociarOrcamento.length }} evento(s)
              selecionado(s)
            </span>
          </div>
          <div class="col-md-2">
            <button
              type="button"
              class="btn btn-outline-danger w-100"
              title="Cancelar Seleção de Eventos para Associar ao Orçamento"
              @click="toggleSelectedEventosAssociarOrcamento"
            >
              Cancelar Seleção
            </button>
          </div>
          <div class="col-md-2">
            <button
              type="button"
              class="btn btn-outline-secondary w-100"
              title="Limpar Seleção de Eventos para Associar ao Orçamento"
              @click="limparSelecaoEventosAssociarOrcamento"
            >
              Limpar Seleção
            </button>
          </div>
          <div class="col-md-2">
            <button
              type="button"
              class="btn btn-outline-success w-100"
              title="Associar Eventos Selecionados ao Orçamento"
              :disabled="eventosSelecionadosAssociarOrcamento.length === 0"
              @click="showLinkEventosOrcamentoModal = true"
            >
              Associar ao Orçamento
            </button>
          </div>
        </template>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-sm table-bordered fs-sm">
        <thead class="bg-teal text-white">
          <tr>
            <th class="w-20">Demandante</th>
            <th class="w-20">Nome</th>
            <th class="w-20">Informações</th>
            <th class="w-40 text-center">Entidades</th>
            <th class="w-5 text-center">Status</th>
            <th
              v-if="selectedEventosAssociarOrcamento"
              class="w-10 text-center"
              title="Selecionar Todos"
            >
              <input
                type="checkbox"
                class="form-check-input"
                :checked="allSelectedEventosAssociarOrcamento"
                @change="toggleSelectAllEventosAssociarOrcamento"
              />
            </th>
            <th class="w-5 text-center">Ações</th>
          </tr>
        </thead>
        <tbody v-if="eventosFiltrados.length > 0">
          <tr v-for="evento in eventosFiltrados" :key="evento.id">
            <td>{{ evento.demandante }}</td>
            <td>{{ evento.nome }}</td>
            <td>
              <p>Entidade Demandante: {{ evento.entidadeDemandante }}</p>
              <p>
                Data: {{ dateTimeSqlToDateBR(evento.dataInicial) }} -
                {{ dateTimeSqlToDateBR(evento.dataFinal) }}
              </p>
              <p>
                Local: {{ evento.local }} - {{ evento.cidade }}/{{
                  evento.estado
                }}
              </p>
              <p class="mb-0">Público: {{ formatWithDot(evento.publico) }}</p>
            </td>
            <td>
              <table class="table table-sm fs-sm">
                <thead>
                  <tr class="text-muted">
                    <th>Nome</th>
                    <th class="text-center">Classificação</th>
                    <th class="text-center">CC/NO</th>
                    <th class="text-end" title="Custo Cadastrado">
                      Custo Cad.
                    </th>
                    <th class="text-end" title="Custo Aprovado">
                      Custo Aprov.
                    </th>
                    <th class="text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(entidade, idx) in evento.entidades" :key="idx">
                    <td>{{ entidade.nome }}</td>
                    <td class="text-center">
                      {{ entidade.classificacao || '-' }}
                    </td>
                    <td class="text-center">
                      {{ entidade.codCCustoPai ? entidade.codCCustoPai : '-' }}
                      <br />
                      {{
                        entidade.codCCustoFilho ? entidade.codCCustoFilho : '-'
                      }}
                      <br />
                      {{
                        entidade.codTBOrcamento ? entidade.codTBOrcamento : '-'
                      }}
                    </td>
                    <td class="text-end">
                      {{ moneyToCurrencyBr(entidade.custo) }}
                    </td>
                    <td class="text-end">
                      {{ moneyToCurrencyBr(entidade.custoAprovado) }}
                    </td>
                    <td
                      v-html="statusEventosTranslate(entidade.status, 'icone')"
                      class="text-center"
                    />
                  </tr>
                  <tr class="fw-bold">
                    <td colspan="3">Custo Total</td>
                    <td class="text-end">
                      {{ moneyToCurrencyBr(evento.custoTotal) }}
                    </td>
                    <td class="text-end">
                      {{ moneyToCurrencyBr(evento.custoTotalAprovado) }}
                    </td>
                    <td />
                  </tr>
                </tbody>
              </table>
            </td>
            <td
              class="text-center"
              v-html="statusEventosTranslate(evento.status, 'icone')"
            />
            <td v-if="selectedEventosAssociarOrcamento" class="text-center">
              <input
                v-if="eventoDisponivelParaAssociar(evento)"
                type="checkbox"
                class="form-check-input"
                v-model="eventosSelecionadosAssociarOrcamento"
                :value="evento"
              />
              <span
                v-else
                class="cp"
                title="Apenas eventos aprovados que ainda não estejam associados a um orçamento podem ser vinculados"
              >
                —
              </span>
            </td>
            <td>
              <div class="d-flex flex-column align-items-center gap-2">
                <div class="d-flex justify-content-center gap-1">
                  <button
                    v-if="showButtonEditDeleteEvento(evento)"
                    type="button"
                    class="btn btn-sm btn-outline-danger btn-icon"
                    title="Excluir"
                    @click="deleteEvento(evento.id)"
                  >
                    <i class="ph-trash" />
                  </button>
                  <button
                    v-if="showButtonEditDeleteEvento(evento)"
                    type="button"
                    class="btn btn-sm btn-outline-warning btn-icon"
                    title="Editar"
                    @click="createEditEvento(evento.id)"
                  >
                    <i class="ph-pencil" />
                  </button>
                </div>
                <div class="d-flex justify-content-center gap-1">
                  <button
                    v-if="showButtonAvaliationEvento(evento)"
                    type="button"
                    class="btn btn-sm btn-outline-success btn-icon"
                    title="Avaliar"
                    @click="avaliationEvento(evento.id)"
                  >
                    <i class="ph-check" />
                  </button>
                  <button
                    v-if="showButtonUnlinkEventoOrcamento(evento)"
                    type="button"
                    class="btn btn-sm btn-outline-danger btn-icon"
                    title="Reverter associação ao orçamento"
                    @click="unlinkEventoOrcamento(evento)"
                  >
                    <i class="ph-arrow-counter-clockwise"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary btn-icon"
                    title="Detalhes"
                    @click="detailsEvento(evento.id)"
                  >
                    <i class="ph-file-text" />
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td
              :colspan="selectedEventosAssociarOrcamento ? 8 : 7"
              class="text-center"
            >
              Nenhum evento encontrado
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import CreateEditEventoModal from '@/components/eventos/CreateEditEventoModal.vue'
import DeleteEventoModal from '@/components/eventos/DeleteEventoModal.vue'
import AvaliationEventoModal from '@/components/eventos/AvaliationEventoModal.vue'
import LinkEventosOrcamentoModal from '@/components/eventos/LinkEventosOrcamentoModal.vue'
import UnlinkEventoOrcamentoModal from '@/components/eventos/UnlinkEventoOrcamentoModal.vue'
import DetailsEventoModal from '@/components/eventos/DetailsEventoModal.vue'
import { mapGetters } from 'vuex'
import { dateTimeSqlToDateBR } from '@/utils/date'
import {
  moneyToCurrencyBr,
  formatWithDot,
  statusEventosTranslate,
} from '@/utils/strings'
import PeriodoAtivoEnum from '@/enum/periodoAtivoEnum'
import StatusEventoEnum from '@/enum/statusEventoEnum'

export default {
  name: 'EventosResult',

  props: {
    filters: {
      type: Object,
      required: true,
    },
    eventos: {
      type: Object,
      required: true,
    },
  },

  components: {
    CreateEditEventoModal,
    DeleteEventoModal,
    AvaliationEventoModal,
    LinkEventosOrcamentoModal,
    UnlinkEventoOrcamentoModal,
    DetailsEventoModal,
  },

  emits: ['searchData'],

  data() {
    return {
      showCreateEditEventoModal: false,
      showDeleteEventoModal: false,
      showAvaliationEventoModal: false,
      showDetailsEventoModal: false,
      showLinkEventosOrcamentoModal: false,
      showUnlinkEventoOrcamentoModal: false,
      eventoIdSelected: null,
      eventoSelectedUnlinkOrcamento: null,
      filtersResult: {
        nome: '',
        status: '',
      },
      selectedEventosAssociarOrcamento: false,
      eventosSelecionadosAssociarOrcamento: [],
      dateTimeSqlToDateBR,
      moneyToCurrencyBr,
      formatWithDot,
      statusEventosTranslate,
    }
  },

  computed: {
    ...mapGetters(['user']),

    periodoCadastroIsOpen() {
      return (
        (Number(this.filters.periodo) === PeriodoAtivoEnum.PROPOSTA &&
          this.eventos.periodo.cadastro === PeriodoAtivoEnum.PROPOSTA) ||
        (Number(this.filters.periodo) === PeriodoAtivoEnum.REFORMULACAO &&
          this.eventos.periodo.cadastro === PeriodoAtivoEnum.REFORMULACAO)
      )
    },

    periodoAprovacaoIsOpen() {
      return (
        (Number(this.filters.periodo) === PeriodoAtivoEnum.PROPOSTA &&
          this.eventos.periodo.aprovacao === PeriodoAtivoEnum.PROPOSTA) ||
        (Number(this.filters.periodo) === PeriodoAtivoEnum.REFORMULACAO &&
          this.eventos.periodo.aprovacao === PeriodoAtivoEnum.REFORMULACAO)
      )
    },

    periodoOrcamentoIsOpen() {
      return (
        (Number(this.filters.periodo) === PeriodoAtivoEnum.PROPOSTA &&
          this.eventos.orcamento.periodoOrcamento ===
            PeriodoAtivoEnum.PROPOSTA) ||
        (Number(this.filters.periodo) === PeriodoAtivoEnum.REFORMULACAO &&
          this.eventos.orcamento.periodoOrcamento ===
            PeriodoAtivoEnum.REFORMULACAO)
      )
    },

    statusEventos() {
      return StatusEventoEnum
    },

    eventosFiltrados() {
      if (!this.eventos.eventos) {
        return []
      }

      return this.eventos.eventos.filter((evento) => {
        const nomeCorresponde = evento.nome
          .toLowerCase()
          .includes(this.filtersResult.nome.toLowerCase().trim())

        const statusCorresponde =
          this.filtersResult.status === '' ||
          Number(evento.status) === Number(this.filtersResult.status)

        return nomeCorresponde && statusCorresponde
      })
    },

    quantidadePorStatus() {
      const statusEventos = [
        {
          status: this.statusEventos.AGUARDANDO_APROVACAO,
          label: 'Aguardando Aprovação',
        },
        { status: this.statusEventos.REPROVADO, label: 'Reprovado' },
        { status: this.statusEventos.REFORMULADO, label: 'Reformulado' },
        { status: this.statusEventos.APROVADO, label: 'Aprovado' },
        { status: this.statusEventos.VINCULADO, label: 'Vinculado' },
      ]

      const contagem = this.eventosFiltrados.reduce((acc, evento) => {
        const status = Number(evento.status)
        acc[status] = (acc[status] || 0) + 1
        return acc
      }, {})

      return statusEventos.map((item) => ({
        status: item.status,
        label: item.label,
        total: contagem[item.status] || 0,
      }))
    },

    existeEventoDisponivelParaAssociarOrcamento() {
      return this.eventosFiltrados.some((evento) =>
        this.eventoDisponivelParaAssociar(evento),
      )
    },

    allSelectedEventosAssociarOrcamento() {
      const eventosSelecionaveis = this.eventosFiltrados.filter((evento) =>
        this.eventoDisponivelParaAssociar(evento),
      )

      return (
        eventosSelecionaveis.length > 0 &&
        eventosSelecionaveis.every((evento) =>
          this.eventosSelecionadosAssociarOrcamento.some(
            (e) => e.id === evento.id,
          ),
        )
      )
    },
  },

  methods: {
    showButtonEditDeleteEvento(evento) {
      return (
        this.periodoCadastroIsOpen &&
        evento.isColigadaOrigem &&
        (this.user.isAdmin || evento.usuarioCriacao === this.user.codUsuario) &&
        Number(evento.status) === this.statusEventos.AGUARDANDO_APROVACAO
      )
    },

    showButtonAvaliationEvento(evento) {
      if (!this.periodoAprovacaoIsOpen || !this.user.isAdmin) {
        return false
      }

      return evento.entidades.some((entidade) => {
        const statusValido =
          Number(entidade.status) === this.statusEventos.AGUARDANDO_APROVACAO ||
          Number(entidade.status) === this.statusEventos.REFORMULADO ||
          Number(entidade.status) === this.statusEventos.APROVADO ||
          Number(entidade.status) === this.statusEventos.REPROVADO

        const coligadaValida =
          entidade.codColigada === null ||
          Number(entidade.codColigada) === Number(this.user.codColigada)

        return statusValido && coligadaValida
      })
    },

    showButtonUnlinkEventoOrcamento(evento) {
      return (
        this.user.isAdmin &&
        this.periodoOrcamentoIsOpen &&
        this.eventoDisponivelParaReverterAssociacao(evento)
      )
    },

    createEditEvento(eventoId) {
      this.eventoIdSelected = eventoId || null
      this.showCreateEditEventoModal = true
    },

    deleteEvento(eventoId) {
      this.eventoIdSelected = eventoId
      this.showDeleteEventoModal = true
    },

    avaliationEvento(eventoId) {
      this.eventoIdSelected = eventoId
      this.showAvaliationEventoModal = true
    },

    unlinkEventoOrcamento(evento) {
      this.eventoSelectedUnlinkOrcamento = evento
      this.showUnlinkEventoOrcamentoModal = true
    },

    detailsEvento(eventoId) {
      this.eventoIdSelected = eventoId
      this.showDetailsEventoModal = true
    },

    eventoDisponivelParaAssociar(evento) {
      if (Number(evento.status) !== this.statusEventos.APROVADO) {
        return false
      }

      const entidade = evento.entidades.find(
        (entidade) =>
          Number(entidade.codColigada) === Number(this.user.codColigada),
      )

      return !!entidade && entidade.orcamentoId === null
    },

    toggleSelectAllEventosAssociarOrcamento(event) {
      const eventosSelecionaveis = this.eventosFiltrados.filter((evento) =>
        this.eventoDisponivelParaAssociar(evento),
      )

      if (event.target.checked) {
        const idsJaSelecionados = this.eventosSelecionadosAssociarOrcamento.map(
          (e) => e.id,
        )
        const novos = eventosSelecionaveis.filter(
          (evento) => !idsJaSelecionados.includes(evento.id),
        )
        this.eventosSelecionadosAssociarOrcamento = [
          ...this.eventosSelecionadosAssociarOrcamento,
          ...novos,
        ]
      } else {
        const idsFiltrados = eventosSelecionaveis.map((evento) => evento.id)
        this.eventosSelecionadosAssociarOrcamento =
          this.eventosSelecionadosAssociarOrcamento.filter(
            (evento) => !idsFiltrados.includes(evento.id),
          )
      }
    },

    toggleSelectedEventosAssociarOrcamento() {
      this.selectedEventosAssociarOrcamento =
        !this.selectedEventosAssociarOrcamento
      if (!this.selectedEventosAssociarOrcamento) {
        this.limparSelecaoEventosAssociarOrcamento()
      }
    },

    limparSelecaoEventosAssociarOrcamento() {
      this.eventosSelecionadosAssociarOrcamento = []
    },

    eventoDisponivelParaReverterAssociacao(evento) {
      if (Number(evento.status) !== this.statusEventos.VINCULADO) {
        return false
      }

      const entidade = evento.entidades.find(
        (entidade) =>
          Number(entidade.codColigada) === Number(this.user.codColigada),
      )

      return !!entidade && entidade.orcamentoId != null
    },

    closeModal(loadListEventos) {
      if (loadListEventos) {
        this.$emit('searchData', true)
      }
      this.showCreateEditEventoModal = false
      this.showDeleteEventoModal = false
      this.showAvaliationEventoModal = false
      this.showDetailsEventoModal = false
      this.showLinkEventosOrcamentoModal = false
      this.showUnlinkEventoOrcamentoModal = false

      this.eventoSelectedUnlinkOrcamento = null
    },
  },
}
</script>

<style scoped>
th,
td {
  padding: 8px;
}
</style>
